/* eslint-disable no-param-reassign */
import { components } from "react-select";
import PropTypes from "prop-types";

const Input = ({ className, isHidden, preserveStyle, children, ...otherProps }) => {
  if (!preserveStyle) {
    // So that the default styles aren't applied, for full customization
    otherProps.getStyles = () => ({});
  }

  return (
    <components.Input {...otherProps} className={className} isHidden={isHidden}>
      {children}
    </components.Input>
  );
};

Input.propTypes = {
  className: PropTypes.string,
  isHidden: PropTypes.bool,
  preserveStyle: PropTypes.bool,
  children: PropTypes.node,
};

Input.defaultProps = {
  className: "",
  isHidden: false,
  preserveStyle: false,
  children: null,
};

export default Input;
